import { TExperienceBuilderTour } from "components/ExperienceBuilderEG/ExperienceBuilderEG.types";
import { Checkbox } from "shared";

type TTourItemProps = {
  tour: TExperienceBuilderTour;
  isSelected: boolean;
  onChange: (value: boolean) => void;
};

function TourItem({ tour, isSelected, onChange }: TTourItemProps) {
  return (
    <div
      className="m-square-card u-text-white"
      style={{ cursor: "pointer" }}
      onClick={() => onChange(!isSelected)}
    >
      <div className="m-square-card__top-wrap">
        <img
          src={tour.BgImage}
          alt={tour.Title}
          className="m-square-card__image"
        />
        <div className="m-square-card__top">
          <Checkbox
            id={tour.Title}
            name={tour.Title}
            checked={isSelected}
            onChange={onChange}
          />
        </div>
      </div>
      <div className="m-square-card__content">
        <h2 className="m-square-card__title">{tour.Title}</h2>
        <ul className="m-square-card__info">
          <li className="m-square-card__item">{tour.InfoText}</li>
        </ul>
      </div>
    </div>
  );
}

export default TourItem;
